<template>
  <div
    class="group bg-surface-container rounded-large relative flex cursor-pointer flex-row items-center overflow-hidden p-3"
    @click="click"
  >
    <CheckableAvatar :member="member" :is-checked="state == OpenFeedbackState.Completed" />
    <span class="text-body-large ml-2 inline-flex items-center">
      {{ $t('common.selfFeedback') }}
    </span>
    <div class="ml-auto flex flex-row items-center">
      <span class="inline-flex items-center">
        <span class="text-label-large"
          >{{ numberOfFeedbacks }}/{{ totalNumberOfQuestions }}
          {{ $t('common.question', totalNumberOfQuestions) }}</span
        >
      </span>
    </div>
    <BaseIcon class="ml-4">chevron_right</BaseIcon>
    <BaseStateLayer />
  </div>
</template>
<script setup lang="ts">
  import { useRouter } from 'vue-router'
  import BaseIcon from '../../../core/components/base/icon/BaseIcon.vue'
  import BaseStateLayer from '../../../core/components/base/state-layer/BaseStateLayer.vue'
  import { OpenFeedbackState } from '../../open-feedbacks/composables/useOpenFeedbacks'
  import CheckableAvatar from '../../../core/components/base/avatar/CheckableAvatar.vue'
  import { useUserStore } from '../../../stores/user.store'

  interface Props {
    numberOfFeedbacks: number
    state: OpenFeedbackState
    totalNumberOfQuestions: number
    surveyId: string
  }

  const props = defineProps<Props>()

  const router = useRouter()

  const { user: member } = useUserStore()

  const click = () => {
    if (props.state == OpenFeedbackState.Completed) {
      router.push({
        name: 'survey-member-feedback',
        params: { surveyId: props.surveyId, memberId: member.id },
      })
    }
    if (props.state == OpenFeedbackState.InProgress) {
      router.push({
        name: 'feedback',
        params: { surveyId: props.surveyId, receiverId: member.id },
      })
    }
  }
</script>
